export default __webpack_public_path__ + "static/media/portfolio-smc360-5.a3053d9d.jpg";